import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import ManageBookingsPage from './pages/ManageBookingsPage';
import ManageUsersPage from './pages/ManageUsersPage';
import ManageParkingSlotsPage from './pages/ManageParkingSlotsPage';
import ParkingSlotDetails from './components/ParkingSlotDetails';
import ManageBankHolidaysPage from './pages/ManageBankHolidaysPage';
import ManageConfigurationsPage from './pages/ManageConfigurationsPage';
import ManageReportsPage from './pages/ManageReportsPage';
import NotAuthorizedPage from './pages/NotAuthorizedPage';
import MiniDrawer from './components/MiniDrawer';
import { useTranslation } from 'react-i18next';


import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

function Layout({ children }) {
  return <MiniDrawer>{children}</MiniDrawer>;
}

function AppRoutes() {
  const { token, userInfo } = useContext(AuthContext);

  const defaultPath = (() => {
    if (userInfo?.can_book) {
      return '/home';
    } else if (userInfo?.is_admin) {
      return '/manage-bookings';
    } else {
      return '/not-authorized';
    }
  })();

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={token ? <Navigate to={defaultPath} /> : <Navigate to="/login" />} />
      <Route
        path="/home"
        element={
          <ProtectedRoute>
            <Layout>
              <HomePage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/manage-bookings"
        element={
          <ProtectedRoute adminOnly>
            <Layout>
              <ManageBookingsPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/manage-users"
        element={
          <ProtectedRoute adminOnly>
            <Layout>
              <ManageUsersPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/manage-parking-slots"
        element={
          <ProtectedRoute adminOnly>
            <Layout>
              <ManageParkingSlotsPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/parking-slots/:slotId"
        element={
          <ProtectedRoute adminOnly>
            <Layout>
              <ParkingSlotDetails />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/manage-bank-holidays"
        element={
          <ProtectedRoute adminOnly>
            <Layout>
              <ManageBankHolidaysPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
          path="/config"
          element={
              <ProtectedRoute adminOnly>
                  <Layout>
                      <ManageConfigurationsPage />
                  </Layout>
              </ProtectedRoute>
          }
      />
      <Route
        path="/manage-reports"
        element={
          <ProtectedRoute adminOnly>
            <Layout>
              <ManageReportsPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route path="/not-authorized" element={<NotAuthorizedPage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

function App() {
  const { ready } = useTranslation();

  if (!ready) {
    return <div>Loading translations...</div>;
  }

  return (
    <AuthProvider>
      <Router>
        <I18nextProvider i18n={i18n}>
          <AppRoutes />
        </I18nextProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;
